module.exports = __webpack_public_path__ + "media/zinc-small.55665b5a.mp4";